import { render, staticRenderFns } from "./ElasticProductMatrixRow.vue?vue&type=template&id=66fb6f3a&"
import script from "./ElasticProductMatrixRow.vue?vue&type=script&lang=js&"
export * from "./ElasticProductMatrixRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports